import styled from '@emotion/styled';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';
import { Container } from '..';

export const ContentPageWrapper = styled.div`
  .head {
    height: 120px;
    background-color: ${(props) => props.theme.color.blue.default};
  }

  h2 {
    ${responsiveFontSize(25)};
  }

  h3 {
    ${responsiveFontSize(22)};
  }

  h4 {
    ${responsiveFontSize(18)};
  }
  .auto-phrase {
    word-break: auto-phrase;
  }
  table {
    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.07);
    margin: 15px auto;
    tr {
      border-bottom: 1px solid ${(props) => props.theme.color.light.tint};

      &:first-of-type(2n + 1) {
        background-color: rgb(250, 250, 250);
      }

      &:first-of-type {
        background-color: ${(props) => props.theme.color.blue.default};
        color: white;
        border: none;
      }
      &:last-of-type {
        border: none;
      }
    }
    td,
    th {
      padding: 8px 16px;
    }
  }
  ul {
    list-style: circle !important;
  }

  ol {
    list-style: decimal !important;
  }

  ul,
  ol {
    margin-bottom: 20px;
    padding-left: 25px;

    li {
      padding-left: 8px;
      margin-bottom: 5px;
    }
  }
`;

export const ContentPageTitle = styled.h1`
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
  font-size: 50px;
  letter-spacing: 0;
  b,
  strong {
    font-weight: 500;
  }
  ${mediaQuery('desktop')} {
    font-size: 44px;
  }
  ${mediaQuery('tablet')} {
    font-size: 40px;
  }
  ${mediaQuery('phone')} {
    font-size: 30px;
  }

  text-align: center;
  margin-bottom: 40px;
`;

export const ContentPageContainer = styled(Container)`
  padding-top: 50px;
  padding-bottom: 50px;
  text-align: justify;
`;
